import { Component, EventEmitter, Input, Output, HostListener, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCalendar } from '@fortawesome/pro-light-svg-icons';
import { PopupInfoService } from '../../services/popup-info.service';

@Component({
  selector: 'app-date-range-picker',
  standalone: true,
  templateUrl: './date-range-picker.html',
  styleUrls: ['./date-range-picker.scss'],
  imports: [CommonModule, FormsModule, FontAwesomeModule],
})
export class DateRangePicker {
  @Input() startDate: string | null = null; // yyyy-mm-dd
  @Input() endDate: string | null = null;
  @Input() placeholder = 'Date Range';
  @Input() panelTitle = 'Rango de fechas';
  @Input() idPrefix = 'drp';
  @Output() rangeChange = new EventEmitter<{ start: string | null; end: string | null }>();

  readonly currentYear = new Date().getFullYear();
  readonly minDate = `${this.currentYear}-01-01`;
  readonly maxDate = `${this.currentYear}-12-31`;

  faCalendar = faCalendar;

  private readonly popupInfo = inject(PopupInfoService);

  showPanel = false;

  togglePanel(ev?: Event) {
    if (ev) ev.stopPropagation();
    this.showPanel = !this.showPanel;
  }

  onKeydown(e: KeyboardEvent) {
    if (!this.showPanel && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      this.togglePanel();
      return;
    }

    if (this.showPanel && e.key === 'Escape') {
      e.preventDefault();
      this.showPanel = false;
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(e: Event) {
    // if click outside, close panel
    if (this.showPanel) {
      const el = e.target as HTMLElement;
      if (el && !el.closest) return;
      // rely on DOM traversal: if no closest .date-range-picker ancestor, close
      if (!(el && el.closest && el.closest('.date-range-picker'))) {
        this.showPanel = false;
      }
    }
  }

  applyNative() {
    this.rangeChange.emit({ start: this.startDate, end: this.endDate });
    this.showPanel = false;
  }

  onStartBlur() {
    this.validateDates();
  }

  onEndBlur() {
    this.validateDates();
  }

  private validateDates() {
    let invalid = false;
    if (this.startDate && (this.startDate < this.minDate || this.startDate > this.maxDate)) {
      invalid = true;
    }
    if (this.endDate && (this.endDate < this.minDate || this.endDate > this.maxDate)) {
      invalid = true;
    }
    if (invalid) {
      this.popupInfo.showWarning('Solo se pueden seleccionar fechas del año actual.');
      this.startDate = null;
      this.endDate = null;
    }
    return invalid;
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.rangeChange.emit({ start: null, end: null });
    this.showPanel = false;
  }
}
